import {
	FiRss,
	FiGlobe,
	FiTruck,
	FiHeart,
	FiTrendingUp,
	FiBook,
	FiBriefcase,
	FiAward,
	FiCheckSquare,
	FiBox,
	FiUsers,
	FiFilm,
	FiFeather,
	FiCpu,
	FiActivity,
	FiMessageCircle,
	FiMusic,
	FiMap,
	FiSmile,
	FiStar,
	FiGithub,
} from 'react-icons/fi';

export const RssFeedCategoriesEnum = {
	CUSTOM: 'CUSTOM',
	GENERAL: 'GENERAL',
	CARS: 'CARS',
	HEALTH: 'HEALTH',
	ECONOMY: 'ECONOMY',
	EDUCATION: 'EDUCATION',
	POLICY: 'POLICY',
	LOTTERY: 'LOTTERY',
	ELECTIONS: 'ELECTIONS',
	FARMING: 'FARMING',
	JOBS: 'JOBS',
	ENTERTAINMENT: 'ENTERTAINMENT',
	NATURE: 'NATURE',
	TECHNOLOGY: 'TECHNOLOGY',
	SPORTS: 'SPORTS',
	GOSSIP: 'GOSSIP',
	MUSIC: 'MUSIC',
	TOURISM: 'TOURISM',
	PET: 'PET',
	WOMAN: 'WOMAN',
	HOROSCOPE: 'HOROSCOPE',
};

export const RssFeedCategoriesTranslationsEnum = {
	CUSTOM: 'Customizado',
	GENERAL: 'Notícias Gerais',
	CARS: 'Carros e Automobilismo',
	HEALTH: 'Saúde e Bem-Estar',
	ECONOMY: 'Economia',
	EDUCATION: 'Educação',
	POLICY: 'Política',
	LOTTERY: 'Loterias',
	ELECTIONS: 'Eleições',
	FARMING: 'Agronegócio',
	JOBS: 'Concursos e Empregos',
	ENTERTAINMENT: 'Entretenimento',
	NATURE: 'Natureza',
	TECHNOLOGY: 'Tecnologia',
	SPORTS: 'Esportes',
	GOSSIP: 'Celebridades e Fofocas',
	MUSIC: 'Música e Artistas',
	TOURISM: 'Turismo e Viagens',
	PET: 'Animais de Estimação',
	WOMAN: 'Dicas Femininas',
	HOROSCOPE: 'Horóscopo',
};

export const RssFeedCategoriesIconsEnum = {
	[RssFeedCategoriesEnum.CUSTOM]: FiRss,
	[RssFeedCategoriesEnum.GENERAL]: FiGlobe,
	[RssFeedCategoriesEnum.CARS]: FiTruck,
	[RssFeedCategoriesEnum.HEALTH]: FiHeart,
	[RssFeedCategoriesEnum.ECONOMY]: FiTrendingUp,
	[RssFeedCategoriesEnum.EDUCATION]: FiBook,
	[RssFeedCategoriesEnum.POLICY]: FiBriefcase,
	[RssFeedCategoriesEnum.LOTTERY]: FiAward,
	[RssFeedCategoriesEnum.ELECTIONS]: FiCheckSquare,
	[RssFeedCategoriesEnum.FARMING]: FiBox,
	[RssFeedCategoriesEnum.JOBS]: FiUsers,
	[RssFeedCategoriesEnum.ENTERTAINMENT]: FiFilm,
	[RssFeedCategoriesEnum.NATURE]: FiFeather,
	[RssFeedCategoriesEnum.TECHNOLOGY]: FiCpu,
	[RssFeedCategoriesEnum.SPORTS]: FiActivity,
	[RssFeedCategoriesEnum.GOSSIP]: FiMessageCircle,
	[RssFeedCategoriesEnum.MUSIC]: FiMusic,
	[RssFeedCategoriesEnum.TOURISM]: FiMap,
	[RssFeedCategoriesEnum.PET]: FiGithub,
	[RssFeedCategoriesEnum.WOMAN]: FiSmile,
	[RssFeedCategoriesEnum.HOROSCOPE]: FiStar,
};
